

export class UserLicenseDetailsStatusInput implements IUserLicenseDetailsStatusInput {
    /** The auto-generated id of the user license details master */
    userLicenseId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IUserLicenseDetailsStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userLicenseId = _data["userLicenseId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UserLicenseDetailsStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserLicenseDetailsStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userLicenseId"] = this.userLicenseId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IUserLicenseDetailsStatusInput {
    /** The auto-generated id of the user license details master */
    userLicenseId: number;
    /** The updated status */
    status: number;
}

